import { Box } from "@mui/system";
import FtdTabs from "./FtdTabs";

const ftd = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <FtdTabs />
      </Box>
    </>
  );
};

export default ftd;
